import type { HjrxCurrentUser } from './app';

export default function access(
  initialState: { currentUser?: HjrxCurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
  };
}
